import * as React from 'react';

import { useTranslation } from 'react-i18next';

import { Modal } from '@shared/components/modal';
import { useModals } from '@shared/contexts';

import { Button } from '@components/button';

import { ModalName } from '../types';
import * as Styled from './trade-link-help-modal.styled.ts';

const TradeLinkHelpModal = () => {
	const { isModalOpen, closeModal } = useModals();

	const { t } = useTranslation(['main', 'help', 'welcome']);

	return (
		<Modal
			isOpen={isModalOpen(ModalName.TRADE_LINK_HELP)}
			title={t('welcome:trade_link_text2')}
			titlePosition='center'
			closeModal={closeModal}
		>
			<Styled.Wrapper>
				<Styled.Subtitle>{t('help:find_trade_link')}</Styled.Subtitle>

				<Styled.List>
					<Styled.Item>{t('help:find_nickname')}</Styled.Item>
					<Styled.Item>{t('help:go_to')}</Styled.Item>
					<Styled.Item>{t('help:click_button')}</Styled.Item>
					<Styled.Item>{t('help:open')}</Styled.Item>
					<Styled.Item>{t('help:trade_text1')}</Styled.Item>
				</Styled.List>
				<Styled.ItemDown>{t('help:down_here')}</Styled.ItemDown>
				<Styled.Actions>
					<Button onClick={closeModal} color='dark'>
						{t('close')}
					</Button>
				</Styled.Actions>
			</Styled.Wrapper>
		</Modal>
	);
};

export default TradeLinkHelpModal;
